<template>
    <Datepicker
        calendarClassName="dp-custom-calendar"
        menuClassName="dp-custom-menu"
        :v-model="modelValue"
        locale="pt-BR"
        weekStart="0"
        inline
        hideOffsetDates
        autoApply
        :enableTimePicker="false"
        :monthChangeOnScroll="false"
        @update:modelValue="handleDateUpdate"
        @updateMonthYear="handleMonthYear"
    >
        <template #day="{ day, date }">
            <template v-if="day != 0 && checkDottedDates(day, date)">
                <span class="dot-date"></span>
                {{ day }}
            </template>
            <template v-else-if="day != 0">
                {{ day }}
            </template>
        </template>
    </Datepicker>
</template>

<script>
import { v4 as uuid } from 'uuid'
import Datepicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';
import ptBR from 'date-fns/locale/pt-BR';
import parse from 'date-fns/parse';
import format from 'date-fns/format';

export default {
  components: {
    Datepicker,
    ptBR,
    format,
    parse,
  },
  inheritAttrs: false,
  props: {
    id: {
      type: String,
      default() {
        return `calendar-${uuid()}`
      },
    },
    type: {
      type: String,
      default: 'text',
    },
    error: String,
    label: String,
    modelValue: {
      type: Date,
      default: new Date(),
    },
    handleMonthYear: {
      type: Function,
      default: ({instance, month, year}) => { },
    },
    dottedDates: {
      type: Array,
      default: [],
    },
    disabledDates: {
      type: Array,
      default: [],
    },
    allowedDates: {
      type: Array,
      default: [],
    },
  },
  emits: ['update:modelValue'],
  methods: {
    format: (date) => format(date, 'dd/MM/yyyy'),
    checkDottedDates(day, date) {
        return this.dottedDates.indexOf(format(date, 'yyyy-MM-dd')) >= 0;
    },
    handleDateUpdate(newDate) {
      console.log('Data selecionada:', newDate);
      this.$emit('update:modelValue', newDate);
    },
  },
}
</script>
<style>
.dp__main {
    @apply w-full;
}
.dp-custom-calendar .dp__calendar_header {
    @apply w-full;
}
.dp-custom-calendar .dp__calendar {
    @apply w-full;
}
.dp-custom-calendar .dp__calendar_item {
    @apply flex items-center text-center justify-center;
}
.dp-custom-calendar .dp__active_date {
  background-color: var(--color-primary);
}
.dp-custom-calendar .dp__today {
  border-color: var(--color-primary);
}
.dp-custom-menu {
    @apply w-full border-none focus:border-none;
}
.dot-date {
  @apply absolute bg-green-600 rounded-full;
  height: 7px;
  width: 7px;
  top: 2px
}
.dp-custom-menu .dp__overlay {
  @apply scrollbar-thin scrollbar-thumb-gray-700 scrollbar-track-gray-200;
}

</style>
